export interface Country {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
}

export const COUNTRIES: Country[] = [
  { code: 'BR', name: 'Brasil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'US', name: 'Estados Unidos', dialCode: '+1', flag: '🇺🇸' },
  { code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CO', name: 'Colômbia', dialCode: '+57', flag: '🇨🇴' },
  { code: 'PE', name: 'Peru', dialCode: '+51', flag: '🇵🇪' },
  { code: 'UY', name: 'Uruguai', dialCode: '+598', flag: '🇺🇾' },
  { code: 'PY', name: 'Paraguai', dialCode: '+595', flag: '🇵🇾' },
  { code: 'BO', name: 'Bolívia', dialCode: '+591', flag: '🇧🇴' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪' },
  { code: 'EC', name: 'Equador', dialCode: '+593', flag: '🇪🇨' },
  { code: 'MX', name: 'México', dialCode: '+52', flag: '🇲🇽' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'ES', name: 'Espanha', dialCode: '+34', flag: '🇪🇸' },
  { code: 'FR', name: 'França', dialCode: '+33', flag: '🇫🇷' },
  { code: 'DE', name: 'Alemanha', dialCode: '+49', flag: '🇩🇪' },
  { code: 'IT', name: 'Itália', dialCode: '+39', flag: '🇮🇹' },
  { code: 'GB', name: 'Reino Unido', dialCode: '+44', flag: '🇬🇧' },
  { code: 'CA', name: 'Canadá', dialCode: '+1', flag: '🇨🇦' },
  { code: 'AU', name: 'Austrália', dialCode: '+61', flag: '🇦🇺' },
];

export const DEFAULT_COUNTRY: Country = COUNTRIES[0]; // Brasil

export function getCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find((country) => country.code === code);
}

export function formatPhoneByCountry(phone: string, country: Country): string {
  const digits = phone.replace(/\D/g, '');

  switch (country.code) {
    case 'BR':
      // Format: (XX) XXXXX-XXXX
      if (digits.length > 11) {
        return formatPhoneByCountry(digits.substring(0, 11), country);
      }
      if (digits.length === 0) return '';
      if (digits.length <= 2) return `(${digits}`;
      if (digits.length <= 7) return `(${digits.substring(0, 2)}) ${digits.substring(2)}`;
      return `(${digits.substring(0, 2)}) ${digits.substring(2, 7)}-${digits.substring(7)}`;

    case 'US':
    case 'CA':
      // Format: (XXX) XXX-XXXX
      if (digits.length > 10) {
        return formatPhoneByCountry(digits.substring(0, 10), country);
      }
      if (digits.length === 0) return '';
      if (digits.length <= 3) return `(${digits}`;
      if (digits.length <= 6) return `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;

    default:
      // Generic format: keep digits only, no formatting
      return digits;
  }
}

export function validatePhoneByCountry(phone: string, country: Country): boolean {
  const digits = phone.replace(/\D/g, '');

  switch (country.code) {
    case 'BR':
      return digits.length === 10 || digits.length === 11; // 10 or 11 digits
    case 'US':
    case 'CA':
      return digits.length === 10;
    default:
      return digits.length >= 7 && digits.length <= 15; // International standard
  }
}

